import { z } from 'zod'

/** 企業員工權限 Schema */
export const permissionSchema = z.object({
  /** 企業官網購票功能 */
  booking: z.boolean()
})

/** 企業員工權限 */
export interface Permission extends z.infer<typeof permissionSchema> {}
